import React from 'react';
import { Outlet } from 'react-router-dom';

import { css } from '@emotion/react';

import Tab from '@components/Common/Tab';

/** SNB > 프로필 Layer > 사용자 설정 */
const MyPage = () => {
  const TAB_OPTIONS = [
    { label: '비밀번호 변경', href: '/mypage/password-change' },
  ];

  return (
    <>
      <div css={container}>
        <div css={title}>사용자 설정</div>
        <Tab options={TAB_OPTIONS} />

        <div css={subContainer}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MyPage;

const container = css`
  padding: 30px 0;
`;

const title = css`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  display: flex;
  height: 34px;
  align-items: center;
  padding: 0 40px;
  margin-bottom: 20px;
`;

const subContainer = css`
  padding: 30px 40px;
`;
